export enum STEP {
    POLICY="Policy",
    INSUREE="Insuree",
    CASE="Case",
    LOCATION="Location",
    TRAVEL="Travel",
    ADL="ADL",
    DBC="DBC",
    PARTY="Party",
    HELP_PLAN="Help Plan",
    SUMMARY="Summary",
    NOTES="Notes",
    CORRESPONDANCE="Correspondance",
    REHOSPITALISATION="Rehospitalisation"
}